<template>
  <loading :active="isLoading" :is-full-page="false"></loading>
  <button
    type="button"
    class="btn btn-template-outlined wide form-control"
    id="favoriteButton"
    @click="toggleFavorite()"
  >
    <i v-if="isFavorite" class="fa fa-heart"></i>
    <i v-else class="fa fa-heart-o"></i>
    <span v-if="isFavorite">Remove from</span>
    <span v-else>Save to</span>&nbsp;
    <img src="/images/myAgon.svg" alt="myAgon" />
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';

export default defineComponent({
  name: 'FavoriteButton',
  components: { Loading },
  props: {
    isFavorite: Boolean,
    itemType: String,
    itemId: String,
    xsrfToken: String,
  },
  emits: ['toggle'],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async toggleFavorite() {
      try {
        this.isLoading = true;
        await fetch(this.getUrl(), {
          method: this.isFavorite ? 'delete' : 'post',
          headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': this.xsrfToken,
          },
        });
        this.$emit('toggle', this.itemId);
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    getUrl(): string {
      if (this.itemType === 'print') {
        return '/my-agon/prints/' + this.itemId;
      }
      if (this.itemType === 'grab-bag') {
        return '/my-agon/grab-bags/' + this.itemId;
      }
      if (this.itemType === 'style') {
        return '/my-agon/styles/' + this.itemId;
      }
      return '';
    },
  },
});
</script>

<style scoped></style>
